export default function (state = null, action) {
	switch (action.type) {

	case 'PUSHER_POLL_RECEIVED':
	  return action.data

	case 'LOGOUT':
	  return null
	
	default:
	  return state
	}
}



// WEBPACK FOOTER //
// ./src/reducers/polls/pusherPoll.js